import * as React from 'react';
import { useSelector } from 'react-redux';

import { Undergrounds } from '../../components/Undergrounds';
import { getUndergroundInfo, getRegionId } from '../../selectors/newbuilding';

export function UndergroundContainer() {
  const underground = useSelector(getUndergroundInfo);
  const regionId = useSelector(getRegionId);

  if (!(underground && underground.length)) {
    return null;
  }

  return <Undergrounds underground={[underground[0]]} regionId={regionId} />;
}
